import { GenericDocAbstractFieldHandler } from "./GenericDocAbstractFieldHandler";
import { IDHFSectionOptions } from "../../PluginManagerDocuments";

export interface ITextLineOptions extends IDHFSectionOptions {}

export class TextLineDocFieldHandler extends GenericDocAbstractFieldHandler {
    getDefaultConfig(): ITextLineOptions {
        return {};
    }

    getXmlValue(): string {
        return JSON.stringify([]);
    }
}
